"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_MESSAGE = exports.ADD_MESSAGE = "ADD_MESSAGE";
var SET_CHAT_STATE = exports.SET_CHAT_STATE = "SET_CHAT_STATE";
var MAXIMISE_CHAT = exports.MAXIMISE_CHAT = "MAXIMISE_CHAT";
var MINIMISE_CHAT = exports.MINIMISE_CHAT = "MINIMISE_CHAT";